import React from "react";

interface PageLayoutProps {
  children: React.ReactNode;
}

export const PageLayout: React.FC<PageLayoutProps> = (props) => {
  return <div style={{ padding: "0 1rem 1rem" }}>{props.children}</div>;
};

export default PageLayout;
